var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var Refresh = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M12,19 C8.13400675,19 5,15.8659932 5,12 L6,12 C6,15.3137085 8.6862915,18 12,18 C14.2208471,18 16.1598786,16.7934041 17.1973068,15 L14,15 L14,14 L19,14 L19,19 L18,19 L18,15.6075866 C16.7751029,17.6404178 14.5463251,19 12,19 Z M10,9 L10,10 L5,10 L5,5 L6,5 L6,8.39241339 C7.22489715,6.35958217 9.45367486,5 12,5 C15.8659932,5 19,8.13400675 19,12 L18,12 C18,8.6862915 15.3137085,6 12,6 C9.77915293,6 7.84012143,7.20659589 6.80269317,9 L10,9 Z" })));
};
Refresh.displayName = 'Refresh';
export default Refresh;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Refresh.js.map